export default "__VITE_ASSET__DXFVZ3oS__"